var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2984 15.7193C11.2984 13.2776 13.2778 11.2982 15.7195 11.2982H40.2809C42.7225 11.2982 44.7019 13.2776 44.7019 15.7193V40.2807C44.7019 42.7224 42.7225 44.7017 40.2809 44.7017H11.2984V15.7193Z",
    stroke: "#00A68B",
    strokeWidth: 3.92982
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4177 11.2727H40.5823C41.6946 11.2727 42.7614 11.7133 43.5479 12.4975C44.3345 13.2818 44.7764 14.3454 44.7764 15.4545V40.5454C44.7764 41.6545 44.3345 42.7182 43.5479 43.5024C42.7614 44.2867 41.6946 44.7273 40.5823 44.7273H15.4177C14.3054 44.7273 13.2386 44.2867 12.4521 43.5024C11.6655 42.7182 11.2236 41.6545 11.2236 40.5454V15.4545C11.2236 14.3454 11.6655 13.2818 12.4521 12.4975C13.2386 11.7133 14.3054 11.2727 15.4177 11.2727Z",
    stroke: "#00A68B",
    strokeWidth: 3.92982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0142 34.4646C23.9832 35.8121 25.9523 36.4848 27.9213 36.4848C29.8904 36.4848 31.8594 35.8121 33.8285 34.4646",
    stroke: "#00A68B",
    strokeWidth: 4.09357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0142 26.3838V24.3636",
    stroke: "#00A68B",
    strokeWidth: 4.09357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8286 26.3838V24.3636",
    stroke: "#00A68B",
    strokeWidth: 4.09357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.8ae6db2c.svg";
export { ForwardRef as ReactComponent };